<template>
  <v-dialog
    v-model="isVisible"
    no-click-animation
    :width="'90%'"
  >
    <v-card>
      <v-card-title>
        <h3>修改經辦人</h3>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <v-toolbar dark color="teal">
              <v-toolbar-title>經辦人：</v-toolbar-title>
              <v-autocomplete
                v-model="selectAgentId"
                :loading="loading"
                :items="agentItems"
                :search-input.sync="searchAgent"
                cache-items
                class="mx-4"
                flat
                hide-no-data
                hide-details
                label="經辦姓名"
                solo-inverted
                item-text="displayName"
                item-value="agentId"
              ></v-autocomplete>
            </v-toolbar>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn class="red" dark text @click="cancelEvent"
          >取消</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn class="primary" dark text @click="confirmEvent"
          >確認</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ContactDialog",
  props:{
    visible: Boolean,
  },
  data() {
    return {
      loading: false,
      selectAgentId: null,
      searchAgent: null,
      agentItems: [],
      isVisible:false,
    };
  },
  watch: {
    searchAgent(val) {
      this.querySelections(val);
    },
    visible(value){
      this.isVisible = value;
    },
    isVisible(value){
      if(!value)
      {
        this.cancelEvent()
      }
    },
  },
  computed: {
    ...mapGetters(['getAgentList']),
    agentList(){
      return this.getAgentList.filter(agent=>agent.enable === true);
    }
  },
  created(){

  },
  methods:{
    querySelections(v) {
      this.loading = true;
      this.agentItems = this.agentList;
      this.agentItems = this.agentList.filter((e) => {
        return (
          (e.displayName || "").toLowerCase().indexOf((v || "").toLowerCase()) >
          -1
        );
      });
      this.loading = false;
    },
    cancelEvent(){
      this.isVisible = false;
      this.$emit('cancelEvent');
    },
    confirmEvent(){
      this.isVisible = false;
      this.$emit('confirmEvent', this.selectAgentId);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/ContactDialog.vue